export default __webpack_public_path__ + "static/media/card_4_paseo.b88b5196.jpg";